import { ITableColumn } from 'views/components/table/type';
import {
  MEDAppointmentSubType,
  IMEDAppointmentSubType
} from 'model/MEDAppointmentSubtype';
import { TableType } from 'model/tableType';
import { ILookup } from 'model/lookup';
import { sortNumerical } from 'utils/sort';

const sortBoolean = (
  a: TableType,
  b: TableType,
  field: MEDAppointmentSubType
) => {
  const valueA = (a as IMEDAppointmentSubType)[field] as boolean;
  const valueB = (b as IMEDAppointmentSubType)[field] as boolean;
  return valueA === valueB ? 0 : valueA ? -1 : 1;
};

export const MED_APPOINTMENT_SUBTYPE_COLUMNS: ITableColumn[] = [
  {
    label: 'Parent Type',
    key: MEDAppointmentSubType.superType,
    comp: {
      sort: (a: TableType, b: TableType) =>
        sort(a, b, MEDAppointmentSubType.superType),
      reverse: (a: TableType, b: TableType) =>
        sort(b, a, MEDAppointmentSubType.superType)
    }
  },
  {
    label: 'Sub-Type Title',
    key: MEDAppointmentSubType.title,
    notWrap: true,
    comp: {
      sort: (a: TableType, b: TableType) =>
        sort(a, b, MEDAppointmentSubType.title),
      reverse: (a: TableType, b: TableType) =>
        sort(b, a, MEDAppointmentSubType.title)
    }
  },
  {
    label: 'Status',
    key: MEDAppointmentSubType.isActive,
    comp: {
      sort: (a: TableType, b: TableType) =>
        sortBoolean(a, b, MEDAppointmentSubType.isActive),
      reverse: (a: TableType, b: TableType) =>
        sortBoolean(b, a, MEDAppointmentSubType.isActive)
    }
  },
  {
    label: 'ID',
    key: MEDAppointmentSubType.id,
    comp: {
      sort: (a: TableType, b: TableType) =>
        sortNumerical(
          a[MEDAppointmentSubType.id]!,
          b[MEDAppointmentSubType.id]!
        ),
      reverse: (a: TableType, b: TableType) =>
        sortNumerical(
          b[MEDAppointmentSubType.id]!,
          a[MEDAppointmentSubType.id]!
        )
    }
  },
  { label: 'Athena Id', key: MEDAppointmentSubType.athenaId },
  { label: 'Duration', key: MEDAppointmentSubType.duration }
];
const sort = (a: TableType, b: TableType, sortField: MEDAppointmentSubType) => {
  let valueA = (a as IMEDAppointmentSubType)[sortField];
  let valueB = (b as IMEDAppointmentSubType)[sortField];
  if (sortField === MEDAppointmentSubType.superType) {
    valueA = (valueA as ILookup).value;
    valueB = (valueB as ILookup).value;
  }
  return valueA!.toString().toLowerCase() > valueB!.toString().toLowerCase()
    ? -1
    : 1;
};
